import FaqModule from '../../modules/faq-module';

class Main {
	constructor() {
        this.metaDescription = document.getElementById('meta-description');
        this.faqModule = new FaqModule();
	}

	run() {
        if (!!this.metaDescription) {
            document.title = 'Häufig gestellte Fragen (FAQ) – anabin: Infoportal zu ausländischen Bildungsabschlüssen';
            this.metaDescription.setAttribute('content', 'Häufig gestellte Fragen (FAQ) zum Thema ausländische Bildungsabschlüsse im Infoportal anabin.');
        }
		this.initializeModules();
		this.faqModule.loadOptions().then(() => {
			this.faqModule.getData().then();
		});
	}

	initializeModules() {
		this.faqModule.initialise();
		this.faqModule.faqgroup.addEventListener(this.faqModule);
	}
}
const main = new Main();
main.run();


